import { ShopList } from '@/api/backend/contract/Shop';
import { pickupPointTypes } from '@/util/map-point-maps/mock';
import {
  PickupPoint,
  PointType,
  PickupPointTypeOption
} from '@/util/map-point-maps/types';

export const getPointTypes = (points: PickupPoint[] | ShopList): PointType[] => {
  return [...new Set(points.map((point) => point.type))];
};

export const getPickupPointTypeOptions = (): PickupPointTypeOption[] => {
  return pickupPointTypes;
};
